<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'saveUserDialog',
  mixins: [snackbarMixin],
  props: {
    isCreateMode: {
      type: Boolean,
    },
    item: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      hasError: false,
      formData: {},
    };
  },
  computed: {
    ...mapGetters('saveUserDialog', ['singularName']),
  },
  created() {
      this.formData = Object.assign({}, this.item);
  },
  mounted() {
    this.visible = true;
    this.initializeData();
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('kullanicilar',['save']),
    fetchData() {
    },
    saveUserRecord() {
      this.isDeleting = true;
      this.isLoading = true;

      this.save({ 
        name: this.name, 
        surname: this.surname, 
        email: this.email, 
        password: this.password 
      })
      .then(() => {
        this.showSuccessMessage('Kullanıcı başarıyla kaydedildi.');
        this.$emit('refresh');
      })
      .catch((err) => {
        this.showErrorMessage(err.response && err.response.data);
      })
      .finally(() => {
        this.isDeleting = false;
        this.isLoading = false;
        this.close();
      });
    },
    initializeData() {
      // this.isLoading = true;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="1080px">
    <v-card>
      <v-card-title style="background-color:rgb(229 231 235)" >
        Kullanı Ekleme Ekranı
      </v-card-title>

      <div class="container">
        <div class="row">
          <div class="col-md-2 schupy-label-title">
            <b>Ad:</b> 
          </div> 
          <div class="col-md-10">
            <v-text-field
                v-model="name"
                id="name"
                type="text"
                clearable
                autocomplete="name"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 schupy-label-title">
            <b>Soyad:</b>
          </div>
          <div class="col-md-10">
            <v-text-field
                v-model="surname"
                id="surname"
                type="text"
                clearable
                autocomplete="name"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 schupy-label-title">
            <b>Email:</b> 
          </div>
          <div class="col-md-10">
            <v-text-field
                  v-model="email"
                  id="email"
                  type="text"
                  clearable
                  autocomplete="email"
                />
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 schupy-label-title">
            <b>Şifre:</b>
          </div>
          <div class="col-md-10">
            <v-text-field
                  v-model="password"
                  id="password"
                  type="text"
                  clearable
                />
          </div>
        </div>
      </div>
      <v-card-actions>
        <v-spacer />

        <v-btn color="red lighten-3" dark @click="close">
          Kapat
        </v-btn>

        <v-btn @click="saveUserRecord" color="green lighten-3" dark>
        Kaydet
        </v-btn>
        
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
